import React, { ReactElement } from 'react';

import {
  ButtonPattern,
  Container,
  Grid,
  Heading,
  SvgIcon,
  Text,
} from '@constellation/core';
import { useNavigate } from '@interstellar/react-app-routing';
import { Button } from 'components/tagging';

import {
  StyledContainer,
  StyledGridItem,
  StyledHeading,
  StyledInnerContentGroup,
  StyledLink,
  StyledOuterContentGroup,
} from './RegistrationSteps.styled';
import { BUTTON_EVENTS } from '../../constants/analytics.constants';
import { RegistrationStepData } from '../../pages/threeStepsToRegisterDelegateAccess/ThreeStepsToRegisterDelegateAccess.config';
import StyledBox from '../style/styledBox/StyledBox';

interface Props {
  description: string;
  data: RegistrationStepData[];
  nextBtn: string;
  nextBtnHref: string;
  previousLink: string;
  previousHref: string;
  externalLink: boolean;
}

function RegistrationSteps({
  description,
  data,
  nextBtn,
  nextBtnHref,
  previousLink,
  previousHref,
  externalLink = false,
}: Props): ReactElement {
  const navigate = useNavigate();

  const handleNavigation = (path: string): void => {
    navigate(path);
  };
  return (
    <StyledContainer marginBottom="06">
      <Grid alignY="center">
        <StyledGridItem>
          <StyledOuterContentGroup marginBottom="none">
            <StyledBox>
              <StyledHeading size="s4">{description}</StyledHeading>
              {data &&
                data.map(
                  ({
                    imageSrc,
                    stepHeading,
                    stepDescription,
                  }: RegistrationStepData) => (
                    <Container
                      padding="none"
                      key={`registration-step-${stepHeading}`}
                    >
                      <SvgIcon color="critical" svg={imageSrc} iconSize="lg" />
                      <StyledInnerContentGroup marginBottom="05">
                        <Heading marginBottom="03" size="s3">
                          {stepHeading}
                        </Heading>
                        <Text>{stepDescription}</Text>
                      </StyledInnerContentGroup>
                    </Container>
                  ),
                )}
              <ButtonPattern marginBottom="none">
                {externalLink ? (
                  <Button
                    variation="primary"
                    iconPosition="right"
                    href={nextBtnHref}
                    taggingLabel={nextBtn}
                  >
                    {nextBtn}
                  </Button>
                ) : (
                  <Button
                    variation="primary"
                    iconPosition="right"
                    onClick={() => handleNavigation(nextBtnHref)}
                    taggingLabel={nextBtn}
                  >
                    {nextBtn}
                  </Button>
                )}

                <StyledLink
                  iconPosition="left"
                  onClick={() => handleNavigation(previousHref)}
                  event={BUTTON_EVENTS.PREVIOUS}
                >
                  {previousLink}
                </StyledLink>
              </ButtonPattern>
            </StyledBox>
          </StyledOuterContentGroup>
        </StyledGridItem>
      </Grid>
    </StyledContainer>
  );
}

export default RegistrationSteps;
